import APIClient from './index';
import _ from 'lodash';

/*************************************************** */
// Product Drops
/*************************************************** */

export const fetchNewProducts = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`ProductDrops?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

// Full membership (including admin-hidden products) ships for one brand at a time — the largest drop has 8k+ members.
export const fetchBrandDrop = Brand_id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`ProductDrops?Brand_id=${Brand_id}&withProducts=1`)
      .then(response => resolve(response.data.drops[0]))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const rebuildNewProducts = Brand_id => {
  return new Promise((resolve, reject) => {
    APIClient.post('ProductDrops/rebuild', { Brand_id })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateNewProductsDrop = (ProductDrop_id, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`ProductDrops/${ProductDrop_id}`, updates)
      .then(response => resolve(response.data.drop))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const hideNewProduct = (ProductDrop_id, Variant_id) => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`ProductDrops/${ProductDrop_id}/variants/${Variant_id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const showNewProduct = (ProductDrop_id, Variant_id) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`ProductDrops/${ProductDrop_id}/variants/${Variant_id}/restore`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
